export default "__VITE_ASSET__BV_1eyLx__"